import { CloseIcon, SearchIcon } from '@assets/icons';
import { IconButton } from '@components/button';
import { Group } from '@components/layout';
import { useModal } from '@components/modal';
import { Typography } from '@components/typography';
import { VolumeDetailsModal } from '@components/volume/agentStudio';
import { type Volume } from '@generated/graphql';
import { formatSizeFromGigabytes } from '@helper-functions/formatSize';
import { useTheme } from '@mui/material';
import { ServerTag } from '../../ServerTag';
import { ResourceCard } from '../ResourceCard';

type VolumeCardProps = {
  volume: Pick<Volume, 'name' | 'volumeId' | 'size' | 'description' | 'createdAt' | 'updatedAt'>;
  workspaceVolume?: boolean;
  onRemove?: VoidFunction;
};

export const VolumeCard = ({ volume, workspaceVolume = false, onRemove }: VolumeCardProps) => {
  const { palette } = useTheme();

  const { showModal: showVolumeDetailsModal } = useModal({
    component: VolumeDetailsModal,
    componentProps: { volume },
    modalProps: { sx: { pt: 7.25 } },
  });

  const handleViewVolumeDetails = () => {
    showVolumeDetailsModal();
  };

  return (
    <ResourceCard>
      <Group alignItems="center" gap={2} flexWrap="wrap">
        <Typography variant="body1" handleOverFlow fitContent>
          {volume.name}
        </Typography>
        <ServerTag
          label={formatSizeFromGigabytes(Number(volume.size))}
          color="default"
          variant="caption2"
        />
        {workspaceVolume && <ServerTag label="Workspace" color="workspace" variant="caption2" />}
      </Group>
      <Group alignItems="center" justifyContent="flex-end" flexShrink={0} gap={1}>
        <IconButton
          Icon={SearchIcon}
          tooltip="Details"
          onClick={handleViewVolumeDetails}
          size={16}
          variant="default"
          color={palette.foreground.paperCard.light}
        />
        {!workspaceVolume && (
          <IconButton
            Icon={CloseIcon}
            tooltip="Remove"
            onClick={onRemove}
            size={16}
            variant="error"
          />
        )}
      </Group>
    </ResourceCard>
  );
};
